import cx from 'classnames';
import {GatsbyImage} from 'gatsby-plugin-image';
import {getGatsbyImageData} from 'gatsby-source-sanity';
import React, {useState, memo} from 'react';

const sanityConfig = {
	projectId: process.env.GATSBY_SANITY_PROJECT_ID,
	dataset: process.env.GATSBY_SANITY_DATASET,
};

export const Image = ({
	asset,
	imageId,
	className,
	width,
	height,
	alt = '',
	src,
	style,
	imgStyle,
	objectFit,
	objectPosition,
	loading,
}) => {
	const [loaded, setLoaded] = useState(false);
	let imageData;

	if ((asset || imageId) && !/gif/.test(asset?._id || imageId)) {
		imageData = getGatsbyImageData(
			asset || imageId,
			{maxWidth: width || 2400},
			sanityConfig,
		);

		// fluidProps = getFluidGatsbyImage(
		//   imageId,
		//   {
		//     maxWidth: width || 2400,
		//     maxHeight: height || undefined,
		//   },
		//   sanityConfig
		// );
	}

	return (
		<figure className={cx(className)}>
			{imageData && !/svg/.test(asset?._id || imageId) ? (
				<>
					<GatsbyImage
						image={{
							...imageData,
							layout: 'fullWidth',
						}}
						alt={alt}
						style={style}
						imgStyle={imgStyle}
						objectFit={objectFit ? objectFit : 'cover'}
						objectPosition={objectPosition}
					/>
				</>
			) : (
				<img
					alt={alt}
					src={src ? src : imageData && imageData.src}
					loading="lazy"
					className={cx('x', 'fade-in-on-load', {
						'is-loaded': loaded,
					})}
					onLoad={() => {
						setLoaded(true);
					}}
					style={style}
				/>
			)}
		</figure>
	);
};

export default memo(Image);
